import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';

import {
  checkUserAsync,
  getListLanguageAsync,
  setTempUserToken,
} from 'store/auth';
import Spinner from '@core/components/spinner/Fallback-spinner';
import { TEMP_USER_TOKEN, USER_VIEW_MODE } from '../helpers/storage';

export const defaultPathName = ['/home', '/login'];
export const cmsPathName = [
  '/homes/course',
  '/homes/course/[slug]',
  '/homes/intake/[slug]',
  '/homes/intake',
  '/homes/intake/intakeGridcard',
  '/homes/workshop',
  '/homes/workshop/view',
  '/loginCms',
  '/homeCms',
  '/homes/signup',
  '/homes/cart',
  '/homes/cart/wishList',
  '/homes/instructor',
  '/overview',
  '/homes/footer/aboutus',
  '/homes/footer/contactus',
  '/homes/footer/privacypolicy',
  '/homes/footer/termsofservice',
];

const withAuthLogin = (Component) => (props) => {
  const dispatch = useDispatch();
  const route = useRouter();
  const { pathname } = route;
  const [isLoading, setIsLoading] = useState(true);
  const metaData = useSelector((state) => state.settingAccount.metaData);
  const preLogin = async () => {
    if (Object.keys(metaData).length) {
      !metaData?.cmsHomePage && defaultPathName.indexOf(pathname) === -1
        ? await route.push('/home')
        : metaData?.cmsHomePage &&
          cmsPathName.indexOf(pathname) === -1 &&
          (await route.push('/homeCms'));
    }
  };
  const authUser = async () => {
    try {
      await dispatch(getListLanguageAsync());
      await dispatch(checkUserAsync());
      await route.push('/');
    } catch (error) {
      if (TEMP_USER_TOKEN.get()) {
        await dispatch(setTempUserToken(undefined));
        await USER_VIEW_MODE.delete();
        await authUser();
      } else {
        setIsLoading(false);
      }
    }
  };

  const listenLoginEvent = (event) => {
    if (event.key === 'userToken' && event.newValue) {
      route.reload();
    }
  };

  useEffect(() => {
    preLogin();
  }, [metaData]);

  useEffect(() => {
    authUser();
    window.addEventListener('storage', listenLoginEvent);
    return () => {
      window.removeEventListener('storage', listenLoginEvent);
    };
  }, []);

  if (isLoading) return <Spinner />;

  return <Component {...props} />;
};

export default withAuthLogin;
